<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div class="row items-center">
      <div class="col-12 q-px-sm">
        <q-btn
          @click="setupAuth0Account()"
          :loading="auth0AccountLoading"
          text
          color="primary"
          class="full-width q-py-xs q-mb-sm"
          label="Setup Sustainability Account"
          v-if="!formData.auth0_id && formData.id"
        ></q-btn>
      </div>
      <div class="col-12 q-px-sm">
        <q-input
          v-model="formData.email"
          label="Email Address"
          :rules="[
            (v) => !!v || 'Email is required',
            (v) => /.+@.+/.test(v) || 'Email must be valid',
          ]"
        ></q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-input
          v-model="formData.fullName"
          label="Name"
          :rules="[(v) => !!v || 'Name is required']"
        ></q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-select
          v-model="formData.role"
          :emit-value="true"
          map-options
          multiple
          use-chips
          label="Role"
          :options="roles"
          :rules="[(v) => !!v || 'Role is required']"
        ></q-select>
      </div>
      <div
        v-if="formData.role && formData.role.includes('Business')"
        class="col-12 q-px-sm"
      >
        <Autocomplete
          label="Assign Supplier"
          :id="formData.business_id"
          clearable
          :items="suppliers"
          option_label="name"
          option_value="id"
          :loading="suppliersLoading"
          @changed="(val) => (formData.business_id = val)"
        />
      </div>
      <div
        v-if="formData.role && formData.role.includes('ImpactBusiness')"
        class="col-12 q-px-sm"
      >
        <Autocomplete
          label="Assign Impact Business"
          :id="formData.impactBusiness_id"
          clearable
          :items="impactBuyers"
          option_label="name"
          option_value="id"
          :loading="impactBuyersLoading"
          @changed="(val) => (formData.impactBusiness_id = val)"
        />
      </div>
      <div
        v-if="formData.role && formData.role.includes('SustainabilityBusiness')"
        class="col-12 q-px-sm"
      >
        <Autocomplete
          label="Assign Sustainability Business"
          :id="formData.sustainabilityBusiness_id"
          clearable
          :items="sustainabilityBusiness"
          option_label="name"
          option_value="id"
          :loading="sustainabilityBusinessLoading"
          @changed="(val) => (formData.sustainabilityBusiness_id = val)"
        />
      </div>
    </div>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";
import Autocomplete from "@/components/autocomplete/autocomplete.vue";

export default {
  components: {
    Autocomplete,
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      suppliers: "business/suppliers/list",
      suppliersLoading: "business/suppliers/listLoading",
      impactBuyers: "business/impact/list",
      impactBuyersLoading: "business/impact/listLoading",
      sustainabilityBusiness: "business/list",
      sustainabilityBusinessLoading: "business/listLoading",
    }),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  watch: {
    data: function () {
      this.init();
    },
  },
  data: () => ({
    // Extra Data
    formData: {},
    roles: [
      {
        label: "Admin",
        value: "Admin",
      },
      {
        label: "User",
        value: "user",
      },
      {
        label: "Impact Buyer",
        value: "ImpactBusiness",
      },
      {
        label: "Supplier",
        value: "Business",
      },
      {
        label: "Sustainability Admin",
        value: "SustainabilityBusiness",
      },
      {
        label: "Good Cause",
        value: "GoodCause",
      },
    ],

    auth0AccountLoading: false,
  }),
  mounted() {
    setTimeout(() => {
      this.init();
    }, 100);
  },
  methods: {
    init() {
      if (this.data != null) {
        this.formData = JSON.parse(JSON.stringify(this.data));
        if (this.currentUserData == "Admin") {
          this.roles = [
            {
              label: "Admin",
              value: "Admin",
            },
            {
              label: "Organization Admin",
              value: "OrgAdmin",
            },
            {
              label: "Organization User",
              value: "OrgUser",
            },
          ];
        }
      } else {
        this.formData = {};
      }
    },
    create() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store
              .dispatch("users/newUser", this.formData)
              .then((result) => {
                this.$emit("loadingStateChanged", false);
                if (result.Result == "Success") {
                  this.$emit("close", true);
                  this.formData = {};
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      }, 200);
    },
    save() {
      this.$emit("loadingStateChanged", true);
      setTimeout(() => {
        this.$store.dispatch("users/saveUser", this.formData).then((result) => {
          this.$emit("loadingStateChanged", false);
          if (result.Result == "Success") {
            this.address = "";
            this.$emit("close", true);
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: "User has been saved",
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
      });
    },
    setupAuth0Account() {
      this.auth0AccountLoading = true;
      this.$store
        .dispatch("users/setupAuth0Account", { id: this.formData.id })
        .then((result) => {
          this.auth0AccountLoading = false;
          if (result.Result == "Success") {
            this.formData.auth0_id = result.Response.auth0_id;
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: "User has been saved",
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        });
    },
  },
};
</script>
